import { Box, Paper, Stack } from "@mui/material";
import { FC } from "react";
import { Skeleton } from "../../../../components/loading/Skeleton";

interface ICPChartSkeletonProps {
  /** Height of the skeleton chart */
  height?: string;
  /** Whether to show title skeleton */
  showTitle?: boolean;
}

/**
 * Skeleton component for ICP charts with consistent styling
 */
export const ICPChartSkeleton: FC<ICPChartSkeletonProps> = ({
  height = "350px",
  showTitle = true,
}) => {
  return (
    <Box>
      <Paper
        elevation={0}
        sx={{
          height,
          width: "100%",
          border: "1px solid #e0e0e0",
          borderRadius: 1,
          padding: 2,
          display: "flex",
          flexDirection: "column",
          boxSizing: "border-box",
          gap: 4,
        }}
      >
        <Stack gap={2}>
          {showTitle && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Skeleton width="200px" height="24px" variant="text" />
              <Skeleton width="80px" height="20px" variant="text" />
            </Box>
          )}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "250px",
            }}
          >
            <Skeleton
              width="100%"
              height="100%"
              variant="rectangular"
              animation="wave"
            />
          </Box>
        </Stack>
      </Paper>
    </Box>
  );
};
